export const NAVIGATION = 'NAVIGATION';
export const REDIRECTION = 'REDIRECTION';
export const INITIALIZATION_ERROR = 'INITIALIZATION_ERROR';

export type NavState = {
  location: string;
  previousLocation: string;
  query: NavigationQueryString;
  queryString: string;
  redirection?: string;
  initErrorStatus?: number;
};

export type NavigationAction = {
  type: typeof NAVIGATION;
  context: PageContext;
};

type RedirectionAction = {
  type: typeof REDIRECTION;
  redirect: string;
};

type InitializationErrorAction = {
  type: typeof INITIALIZATION_ERROR;
  initErrorStatus: number;
  queryString?: string;
};

export type NavActions = NavigationAction | RedirectionAction | InitializationErrorAction;
